import PnmContainer from './PnmContainer';

export default PnmContainer;
